
import { npuEventStatistics } from '../utils/npuTracker'
Vue.component("question_answer_panel", {
  props: {
      user_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      current_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      course_id: {
          type: String,
          required: true,
          default: ""
      },
      has_login: {
          type: Boolean,
          default: true
      }
  },
  created() {
    this.getTeachers()
  },
  watch: {
      current_info: {
          handler(newVal) {
              if (Object.keys(newVal).length && this.has_login) {
                  this.initList();
              }
          },
          immediate: true
      },
      has_login: {
          handler(newVal, oldVal) {
              if(Object.keys(this.current_info).length){
                  this.initList();
              }
          },
          immediate: true,
      }
  },
  data() {
      this.global = window
      return {
          showPage: 1,
          rules: {
              title: [
                  {required: true, message: this.$t('请输入标题'), trigger: 'blur'},
                  // { min: 0, max: 30, message: '不能超过30个字符', trigger: 'change' }
              ],
              content: [{required: true, message: this.$t('请输入内容'), trigger: 'blur'}]
          },
          formModel: {
              title: "",
              content: "",
          },
          hasMore: true,
          pagination: {
              page: 1,
              size: 10
          },
          questionList: [],
          currentItem: {},
          loading: false,
          isAnonymous: false,
          teachers_code: []
      }
  },
  methods: {
      initList() {
          this.pagination.page = 1
          this.hasMore = true
          this.getQuestionList()
      },
      getTeachers() {
        API.reqTeachers({ id: this.course_id }).then(res => {
          if (res.status == 200) {
            this.teachers_code = res.data?.map(item => item.userCode)
          }
        })
      },
      getQuestionList() {
          if (!this.hasMore || !this.has_login) return
          this.loading = true
          const params = {
              link_id: this.course_id,
              extend_link_id: this.current_info.guid_,
              extend_type: window.location.pathname.includes("mooc") ? "04" : window.location.pathname.includes("spoc") ? "02" : window.location.pathname.includes("training") ? '06': '',
              user_id_of_unread: this.user_info.user_code,
              height: 1,
              ...this.pagination
          }
          API.reqQuestion(params).then(res => {
              if (res.error_msg === "Success") {
                  this.$emit("update:length", res.extend_message.count)
                  if (this.pagination.page === 1) {
                      this.questionList = res.extend_message.results;
                  } else {
                      this.questionList = [...this.questionList, ...res.extend_message.results];
                  }
                  if (res.extend_message.next) {
                      this.pagination.page++;
                      this.hasMore = true;
                  } else {
                      this.hasMore = false;
                  }
              }
          }).finally(() => {
              this.loading = false
          })
      },
      toPage(page) {
          this.showPage = page;
      },
      backHandle() {
          this.toPage(1);
          this.$refs.form.resetFields();
          this.initList();
      },
      submitHandle() {
          this.$refs.form.validate((valid) => {
              if (valid) {
                  this.loading = true
                  API.reqSensitiveWord(this.formModel.title + this.formModel.content, this.$t('内容'), () => API.addQuestion({
                      title: this.formModel.title,
                      content: this.formModel.content,
                      user_id: this.user_info.user_code,
                      user_name: this.user_info.nick_name,
                      user_roles: this.user_info.roles,
                      link_id: this.course_id,
                      extend_link_id: this.current_info.guid_,
                      extend_type: window.location.pathname.includes("mooc") ? "04" : window.location.pathname.includes("spoc") ? "02" : window.location.pathname.includes("training") ? '06': '',
                      extend_message: this.current_info.chapter_name,
                      extend_url: window.location.pathname + '?semester=' + window.courseSemester,
                      anonymity: this.isAnonymous
                  })).then(res => {
                      if (res.error_code) {
                          this.$message.success({message: this.$t("发表成功"), customClass: 'qustion_success'});
                          this.$refs.form.resetFields();
                          this.isAnonymous = false;
                          this.showPage = 1;
                          this.initList()
                      } else {
                          this.$message.error(res.extend_message)
                      }
                      //西工大统计-课程资源点播学习
                        let courseTypeName = window.location.pathname.includes("mooc") ? '公开课' :
                            window.location.pathname.includes("spoc") ? '班级课' :
                            window.location.pathname.includes("training") ? '培训课' : '其他';
                        let courseTypeCode = window.location.pathname.includes("mooc") ? 'mooc' :
                            window.location.pathname.includes("spoc") ? 'spoc' :
                            window.location.pathname.includes("training") ? 'training' : 'other';
                        npuEventStatistics({
                            eventCode: 'create_quiz',// 
                            eventOpeartionObjectCatelogName: courseTypeName,//操作对象所属分类名称
                            eventOpeartionObjectCatelogCode: courseTypeCode,//操作对象所属分类   
                            eventOpeartionObjectCatelogDetail: courseTypeName,//操作对象所属分类描述
                            eventOpeartionObjectName: this.current_info.chapter_name,//操作对象名称
                            eventOpeartionObjectCode: this.current_info.guid_,//操作对象code
                            eventOpeartionObjectDetail: this.formModel.content,//操作对象内容
                            eventOpeartionResult: res.error_code?'成功':'失败'
                        })
                  }).finally(() => {
                      this.loading = false
                  })
              }
          })
      },
      handleToDetail(data) {
          this.showPage = 3
          this.currentItem = data
      },
      detailToFirst() {
          this.toPage(1);
          this.initList();
      },
      handlePublicChange(id, permissions) {
        const index = this.questionList.findIndex(item => item.topic_id === id);
        this.questionList.splice(index, 1, { ...this.questionList[index], permissions });
      },
      showPublicModal(data, isEdit) {
        this.$refs["public-qa-modal"].visible = true;
        if (isEdit) {
          this.$refs["public-qa-modal"].publicValue = data.permissions;
        }
        this.currentItem = data
      }
  },
  template: `
  <div class="question_answer_panel" v-loading="loading">
    <div v-if="showPage == 1" class="page1" v-infinite-scroll="getQuestionList" :infinite-scroll-delay="500" :infinite-scroll-distance="50" :infinite-scroll-immediate="false">
      <el-tooltip effect="dark" :content="$t('登录后可使用问答功能')" placement="top">
        <el-button class="add_btn" style="cursor: not-allowed" type="primary" v-show="!has_login">{{$t('发起提问')}}</el-button>
      </el-tooltip>
      <el-button type="primary" @click="toPage(2)" v-if="has_login">{{$t('发起提问')}}</el-button>
      <question_answer_item v-for="item in questionList" key="item.topic_id" :data="item" :course_id="course_id" :teachers_code="teachers_code" @showPublicModal="(isEdit) => showPublicModal(item, isEdit)" @onPublicChange="handlePublicChange" @toDetail="handleToDetail(item)" @delete="initList" :user_info="user_info" />
    </div>
    <div v-else-if="showPage == 2" class="page2">
      <span class="back-container" @click="backHandle"><i class="el-icon-arrow-left"></i>{{$t('返回')}}</span>
      <div class="relative-content"><span :title="current_info.chapter_name">{{$t('相关内容')}}：{{current_info.chapter_name}}</span></div>
      <el-form :model="formModel" :rules="rules" ref="form">
        <el-form-item :label="$t('标题')" prop="title">
          <el-input show-word-limit :maxlength="30" type="text" v-model="formModel.title" :placeholder="$t('请输入标题...')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('内容')" prop="content">
          <el-input type="textarea" :maxlength="200" v-model="formModel.content" :placeholder="$t('请输入标题...')" maxlength="300" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-container">
        <el-button type="primary" size="small" @click="submitHandle">{{$t('发表')}}</el-button>
        <el-tooltip :content="$t('匿名仅对课程内同学生效，老师仍可见真实姓名')">
          <el-checkbox v-if="global.location.pathname.includes('spoc') || window.location.pathname.includes('training')" v-model="isAnonymous">{{$t('匿名发表')}}</el-checkbox>
        </el-tooltip>
      </div>
    </div>
    <div v-else class="page3">
      <question_detail :user_info="user_info" :teachers_code="teachers_code" :current_info="current_info" :topic_id="currentItem.topic_id" @back="detailToFirst" :course_id="course_id" />
    </div>
    <public_qa_modal ref="public-qa-modal" :course_id="course_id" :topic_id="currentItem.topic_id" @onPublic="handlePublicChange" />
  </div>
`
})